import styled from "styled-components";
import { units } from "@m/alchemy-theme";
export const Layout = styled.div `
  display: flex;
  > *:first-child {
    margin-right: 24px;
  }
  flex-wrap: wrap;
  justify-content: center;
`;
export const PreviewColumn = styled.div `
  width: 180px;
`;
export const FormColumn = styled.div `
  flex-grow: 1;
  flex-basis: 1;
  position: relative;
`;
export const FormFields = styled.div `
  display: flex;
  flex-direction: column;
  padding-top: ${units(2)};

  > *:not(:last-child) {
    margin: 0 0 16px;
  }
`;
export const ImagePreviewWrapper = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 180px;

  img {
    max-height: 100%;
    max-width: 100%;
  }
`;
export const DimensionFields = styled.div `
  margin-top: ${units(1)};
  display: flex;
  align-items: flex-end;

  > *:not(:last-child) {
    margin-right: ${units(1)};
  }

  input {
    min-width: 0;
    width: auto;
  }
`;
export const MarginFields = styled.div `
  display: flex;
  align-items: flex-end;
  max-width: calc(100% - ${units(1)});
  flex-wrap: wrap;
  /* Aligns border-radius field with image dimension fields */
  margin-bottom: 29px;
  > *:not(:last-child) {
    margin-right: ${units(1)};
  }
  input {
    min-width: 0;
    width: 72px;
  }

  div {
    flex-shrink: 1;
    min-width: 0;
  }
`;
